import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

import { TagsList } from './NewsPrimary';
import Spinner from '../widgets/Spinner';

import './news-list.scss';

class NewsItem extends PureComponent {
  render() {
    const { id, dateDisplay, title, previewText, tags } = this.props;

    return (
      <Link
        to={`${this.props.pathname}${id}/`}
        className="news-list-item"
      >
        <div className="news-list-item-content">
          <h2 dangerouslySetInnerHTML={{ __html: title }} />

          <span className="news-list-item-date">{dateDisplay}</span>

          <p dangerouslySetInnerHTML={{ __html: previewText }} />

          <div className="news-list-item-links">
            {(!!this.props.tags) &&
              <TagsList tags={tags} />
            }

            <div className="btn btn-arrowed">
              Подробнее <span className="icon">→</span>
            </div>
          </div>
        </div>
      </Link>
    );
  }
}

class NewsList extends PureComponent {
  render() {
    return (
      <div className="news-list-container">
        {(!this.props.items.length && !this.props.isFetching) &&
          <div className="news-list-empty">
            <span>Новостей по&nbsp;данному запросу не&nbsp;найдено</span>
          </div>
        }

        {(!!this.props.items.length) &&
          <ul className="news-list">
            {this.props.items.map((item, key) =>
              <li key={key}>
                <NewsItem
                  {...item}
                  pathname={this.props.pathname}
                />
              </li>
            )}
          </ul>
        }

        {(this.props.isFetching) &&
          <div className="news-list-spinner">
            <Spinner />
          </div>
        }

        {(this.props.hasMore && !this.props.isFetching) &&
          <div className="news-list-load-more">
            <button
              type="button"
              className="btn btn-flex"
              onClick={this.props.loadMore}
            >
              Показать еще
            </button>
          </div>
        }
      </div>
    );
  }
}

NewsList.propTypes = {
  pathname: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.object),
  isFetching: PropTypes.bool,
  hasMore: PropTypes.bool,
  loadMore: PropTypes.func
};

export default NewsList;



// WEBPACK FOOTER //
// ./src/components/News/NewsList.js